/* Autogenerated file. Do not edit manually. */
/* tslint:disable */
/* eslint-disable */

import { Contract, Signer, utils } from "ethers";
import { Provider } from "@ethersproject/providers";
import type {
  IPropertyValidator,
  IPropertyValidatorInterface,
} from "../IPropertyValidator";

const _abi = [
  {
    inputs: [
      {
        internalType: "address",
        name: "tokenAddress",
        type: "address",
      },
      {
        internalType: "uint256",
        name: "tokenId",
        type: "uint256",
      },
      {
        internalType: "bytes",
        name: "propertyData",
        type: "bytes",
      },
    ],
    name: "validateProperty",
    outputs: [],
    stateMutability: "view",
    type: "function",
  },
];

export class IPropertyValidator__factory {
  static readonly abi = _abi;
  static createInterface(): IPropertyValidatorInterface {
    return new utils.Interface(_abi) as IPropertyValidatorInterface;
  }
  static connect(
    address: string,
    signerOrProvider: Signer | Provider
  ): IPropertyValidator {
    return new Contract(address, _abi, signerOrProvider) as IPropertyValidator;
  }
}
